/* eslint-disable import/no-cycle */
import React from "react";
import { SvgProps } from ".";

export const Trash: React.FC<SvgProps> = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    aria-labelledby="Plus"
  >
    <title id="Trash">Trash</title>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group">
        <rect id="Rectangle" x="0" y="0" width="40" height="40" />
        <line
          x1="33.7493891"
          y1="8.75"
          x2="6.24938906"
          y2="8.75000781"
          id="Path"
          stroke="#252525"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="16.25"
          y1="16.25"
          x2="16.25"
          y2="26.25"
          id="Path"
          stroke="#252525"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="23.75"
          y1="16.25"
          x2="23.75"
          y2="26.25"
          id="Path"
          stroke="#252525"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.2493891,8.75 L31.2493891,32.5 C31.2493891,33.1903559 30.689745,33.75 29.9993891,33.75 L9.99938906,33.75 C9.30903313,33.75 8.74938906,33.1903559 8.74938906,32.5 L8.74938906,8.75"
          id="Path"
          stroke="#252525"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g
          d="M26.25,8.75 L26.25,6.25 C26.25,4.86928813 25.1307119,3.75 23.75,3.75 L16.25,3.75 C14.8692881,3.75 13.75,4.86928813 13.75,6.25 L13.75,8.75"
          id="Path"
          stroke="#252525"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

export default {};
